import { httpClient } from "@utils";
import { ContextOptions, ApiRequestContextData } from "@utils/api-config/types";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { PageableCollection } from "@api-types/common";
import { UserAccounts } from "@api-types/user/UserAccounts";

export default class UserAccountsApiService {
	static baseUrl(context: ApiRequestContextData | null) {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/user-accounts`;
	}
	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getUserAccounts(
		options?: ContextOptions
	): Promise<PageableCollection<UserAccounts>> {
		const context = getApiRequestContext(options);
		const headers = this.getRequestHeaders(context);

		return await httpClient.get(
			`${this.baseUrl(context)}/users/${
				context?.userId
			}?embed=accountType,currency&shouldCompileMulticardsAccounts=true`,
			headers
		);
	}

	static async activateUserAccount(
		userAccountAbrv: { userAccountTypeAbrv: string },
		options?: ContextOptions
	): Promise<PageableCollection<UserAccounts>> {
		const context = getApiRequestContext(options);
		const headers = this.getRequestHeaders(context);

		return await httpClient.post(
			`${this.baseUrl(context)}/activate`,
			JSON.stringify(userAccountAbrv),
			headers
		);
	}
}
